window.collapse = function (clickedElement) {
    const label = clickedElement.querySelector('.collapse-link-label');
    const icon = clickedElement.querySelector('.collapse-link-icon');

    if (label.classList.contains('collapsed')) {
        label.innerText = 'Show More';
        icon.classList.remove('fa-chevron-up');
        icon.classList.add('fa-chevron-down');
    } else {
        label.innerText = 'Show Less';
        icon.classList.remove('fa-chevron-down');
        icon.classList.add('fa-chevron-up');
    }
};

document.addEventListener('DOMContentLoaded', () => {
    const navbarToggler = document.getElementById('navbarToggler');
    const navbarSupportedContent = document.getElementById(
        'navbarSupportedContent'
    );

    if (document.querySelector('nav.mcp-navbar-large')) {
        // Retrieve translated strings
        const openNavLabel = document
            .getElementById('open-nav-label')
            .textContent.trim();
        const closeNavLabel = document
            .getElementById('close-nav-label')
            .textContent.trim();

        // Update aria-label based on collapse events
        navbarSupportedContent.addEventListener('shown.bs.collapse', () => {
            navbarToggler.setAttribute('aria-expanded', 'true');
            navbarToggler.setAttribute('aria-label', closeNavLabel);
        });

        navbarSupportedContent.addEventListener('hidden.bs.collapse', () => {
            navbarToggler.setAttribute('aria-expanded', 'false');
            navbarToggler.setAttribute('aria-label', openNavLabel);
        });
    }
});
